import React from 'react';

import Logo from '../assets/img/logo.png';
import playStoreIcon from '../assets/img/play-store.svg';
import appleIcon from '../assets/img/apple.svg';
import { Link } from 'react-router-dom';

const DownloadApp = () => {
    return (
        <section className="app-sec">
            <div className="container c_container">
                <div className="row">
                    <div className="col-lg-6 offset-lg-6">
                        <div className="app_content">
                            <img data-aos="fade-up" src={Logo} style={{ marginBottom: '10px' }} />
                            <h3 className="heading-gradient" data-aos="fade-up">Download Our App Now</h3>
                            <p className="para-18" data-aos="fade-up">We are the only fully licensed mobile Xray radiology services App in India. Now available on both Google Play Store and App Store. Book Your Xray On Door and access your smart reports and tracke your services anytime anywhere in Pan India.</p>
                            <div className="app_btn" data-aos="fade-up">
                                <Link to="#">
                                    <img src={playStoreIcon} />
                                    <p>Get It On<span>Google Play</span></p>
                                </Link>
                                <Link to="#">
                                    <img src={appleIcon} />
                                    <p>Available now on the <span>App Store</span></p>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default DownloadApp;